import * as React from 'react';
import { WebPortalClient } from "webportalclient";
import DocumentTitle from '../../misc/components/DocumentTitle';
import { ODataParams, Query } from '../../Components/Query';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { DataCorrectionQueryTable } from './DataCorrectionQueryTable';
import { useWebPortalApiClient } from '../../misc/api/WebPortalTokenClient';

export interface DataCorrectionListScreenProps {
    rowSelectionChanged
}

export const DataCorrectionListScreen = (props: DataCorrectionListScreenProps) => {
    const client = useWebPortalApiClient();
    const { study } = useCurrentStudyConfigurationContext();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `studyId eq ${study.id}`;

        return await client.client.getDcfRequests(undefined, filter, params.orderby, 'site,subject,visit,session', params.top, params.skip);
    }

    return (
        <Query onRefresh={handleRefresh} initialOrdering={[{ field: "label", condition: "asc" }]}>
            <DataCorrectionQueryTable onRowSelection={(dcfRequestId) => props.rowSelectionChanged(dcfRequestId)} />
        </Query>
    );
};
